import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

interface PickListHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  hasNextPage: boolean;
  onLoadMore: () => void;
  isLoading: boolean;
  loadMoreLabel: string;
}

export function PickListHeader({
  search,
  onSearchChange,
  searchPlaceholder,
  hasNextPage,
  onLoadMore,
  isLoading,
  loadMoreLabel,
}: PickListHeaderProps) {
  return (
    <div>
      <InputText
        value={search}
        onChange={(e) => {
          onSearchChange(e.target.value);
        }}
        placeholder={searchPlaceholder}
        className="access-manager-search"
      />
      {hasNextPage && (
        <Button
          label={loadMoreLabel}
          size="small"
          outlined
          onClick={onLoadMore}
          loading={isLoading}
          className="access-manager-load-more"
        />
      )}
    </div>
  );
}
